export default {
	title: "ResourcesEdit",
	description: "schemas_resources_edit",
	type: "object",
	properties: {}
};
